import React from 'react';
import ReactDOM from 'react-dom';
import Index from './index.jsx';

import T from './nls/translate.js';

document.title = T.current.HTML.title;
document.body.setAttribute('class', 'slx-'+T.current.key);

ReactDOM.render(
		React.createElement(Index),
		document.getElementById('content')
);
